import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class MinTeamsCheckedValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const minCheckedTeamsQuantity = 2;
        let teams = stacking.getActiveTeams();

        let checkedTeamsQuantity = 0;
        Object.values(teams).map((team) => {
            // @ts-ignore
            if (team.checked) {
                checkedTeamsQuantity++;
            }
        });

        if (minCheckedTeamsQuantity > checkedTeamsQuantity) {
            this.addError(`At least ${minCheckedTeamsQuantity} teams should be checked.`);
        }
    }
}

export default MinTeamsCheckedValidator;
